import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, message, Checkbox } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import fetchData from "../../services/requester";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadImg from "../upload-img";

const PageAdd = (props) => {
  const [data, setData] = useState("");
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  const getData = () => {
    const { pageId } = props;
    let reqURL = "pages/detail/" + pageId;
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        if (data) {
          setData(data[0] || "");
          setDefaultData(data[0] || "");
          setLoading(false);
        }
      },
      "GET"
    );
  };

  const setDefaultData = (data) => {
    form.setFieldsValue({
      pageTitle: data?.pageTitle,
      pageSubTitle: data?.pageSubTitle,
      pageName: data?.pageName,
      pageContent: data?.pageContent,
      imageURL: data?.imageURL,
      topMenu: data?.topMenu,
    });
  };

  const onFinish = (values) => {
    setLoading(true);
    let reqURL = "pages/" + (props.isEditMode ? "update" : "add");
    let reqOBJ = values;

    reqOBJ.pageName = reqOBJ?.pageTitle
      ?.toLowerCase()
      ?.replace(/\s+/g, "-")
      ?.replace(/[^\w\s-]/g, "");

    props?.isEditMode && (reqOBJ.pageId = props?.pageId);

    fetchData(reqURL, reqOBJ, (data) => {
      setLoading(false);
      data?.success
        ? props.handleAdd()
        : message.error("Oops! Something went wrong.");
    });
  };

  const handleUpload = (imageURL) => {
    form.setFieldsValue({ imageURL });
  };

  useEffect(() => {
    props?.isEditMode && getData();
  }, []);

  return (
    <React.Fragment>
      <Form
        name="page-add"
        form={form}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 18,
        }}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{ topMenu: true }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Page Title"
              name="pageTitle"
              rules={[
                {
                  required: true,
                  message: "Please input Page Title!",
                },
              ]}
            >
              <Input placeholder="Enter Page Title" />
            </Form.Item>

            <Form.Item label="Page Sub Title" name="pageSubTitle">
              <Input placeholder="Enter Page Sub Title" />
            </Form.Item>

            <Form.Item
              label="Page Content"
              name="pageContent"
              getValueFromEvent={(event, editor) => {
                const data = editor.getData();
                return data;
              }}
            >
              <CKEditor
                data={data?.pageContent || ""}
                editor={ClassicEditor}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "380px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Image" name="imageURL">
              <UploadImg
                path="uploadfile"
                type="file-input"
                handleUpload={handleUpload}
                image={data?.imageURL}
              />
            </Form.Item>
            <Row>
              <Col span={5}></Col>
              <Col span={10}>
                <Form.Item name="topMenu" valuePropName="checked">
                  <Checkbox>Include in Top Menu</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        <Form.Item
          wrapperCol={{
            offset: 5,
            span: 15,
          }}
          className="btn-row"
        >
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            icon={!props?.isEditMode ? <PlusOutlined /> : <EditOutlined />}
          >
            {!props?.isEditMode ? "Add Page" : "Update Page"}
          </Button>
        </Form.Item>
      </Form>
    </React.Fragment>
  );
};

export default PageAdd;
